import { AxiosError } from 'axios'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

import { del } from '../../../utils/api'
import { ApiErrors, handleApiErrors } from '../../../utils/apiErrors'

export const useDeleteOptimizationProcess = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  return useMutation(
    ['optimization-processes', 'delete'],
    (optimizationProcessId: number) =>
      del<void>(`/optimization-processes/${optimizationProcessId}/`),
    {
      onError: (error: AxiosError<ApiErrors>) => {
        // handleApiErrors already displays the error message from the backend
        handleApiErrors(error)
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['optimization-processes'])
        toast.success(t('Optimization process deleted successfully'))
      },
    }
  )
}
